import { render, staticRenderFns } from "./Filepond.vue?vue&type=template&id=062c8264&"
import script from "./Filepond.vue?vue&type=script&lang=js&"
export * from "./Filepond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports